export const TENURE = {
    Non: "Non",
    Regular: "Regular",
    Parttime: "Part-Time",
    Probationary: 'Probationary',
    Fixedterm: 'Fixed-Term',
    Contractual: 'Contractual',
    Guestlecturer: 'Guest-Lecturer'
}